"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSave = exports.load = exports.save = exports.loadMeta = exports.getKeyMeta = exports.getSaveSlot = exports.setSaveSlot = exports._currentSaveSlot = void 0;
var localStorer_sidecar_1 = require("@lib/localStorer-sidecar");
var voyageSaver_crew_sidecar_1 = require("./voyageSaver_crew-sidecar");
var voyageSaver_equipment_sidecar_1 = require("./voyageSaver_equipment-sidecar");
var voyageSaver_meta_sidecar_1 = require("./voyageSaver_meta-sidecar");
var voyageSaver_starmap_sidecar_1 = require("./voyageSaver_starmap-sidecar");
var voyageSaver_status_sidecar_1 = require("./voyageSaver_status-sidecar");
var version = 1;
var key = 'voyage:' + version + ':';
exports._currentSaveSlot = getSaveSlot();
function setSaveSlot(saveSlot) {
    exports._currentSaveSlot = saveSlot;
    localStorer_sidecar_1.localStorer.save(key + 'saveslot', version, exports._currentSaveSlot, false);
}
exports.setSaveSlot = setSaveSlot;
function getSaveSlot() {
    return localStorer_sidecar_1.localStorer.load(key + 'saveslot', version) || '1';
}
exports.getSaveSlot = getSaveSlot;
function getKeyMeta(saveSlot) {
    return key + saveSlot + ':meta';
}
exports.getKeyMeta = getKeyMeta;
var loadMeta = function (slot) {
    var meta = localStorer_sidecar_1.localStorer.load(getKeyMeta(slot), version);
    if (!meta) {
        return null;
    }
    return meta;
};
exports.loadMeta = loadMeta;
var save = function () {
    console.log('saver', 'saving', exports._currentSaveSlot);
    var meta = voyageSaver_meta_sidecar_1.voyageSaver_meta.save();
    localStorer_sidecar_1.localStorer.save(getKeyMeta(exports._currentSaveSlot), version, meta, true);
    var status = voyageSaver_status_sidecar_1.voyageSaver_status.save();
    var crew = voyageSaver_crew_sidecar_1.voyageSaver_crew.save();
    var equipment = voyageSaver_equipment_sidecar_1.voyageSaver_equipment.save();
    var starmap = voyageSaver_starmap_sidecar_1.voyageSaver_starmap.save();
    var data = {
        meta: meta,
        status: status,
        crew: crew,
        equipment: equipment,
        starmap: starmap,
    };
    localStorer_sidecar_1.localStorer.save(key + exports._currentSaveSlot, version, data, true);
};
exports.save = save;
var load = function (onFailure) {
    if (onFailure === void 0) { onFailure = function () { }; }
    console.log('loading', exports._currentSaveSlot);
    var d = localStorer_sidecar_1.localStorer.load(key + exports._currentSaveSlot, version);
    if (d) {
        voyageSaver_status_sidecar_1.voyageSaver_status.load(d.status);
        voyageSaver_crew_sidecar_1.voyageSaver_crew.load(d.crew);
        voyageSaver_equipment_sidecar_1.voyageSaver_equipment.load(d.equipment);
        voyageSaver_starmap_sidecar_1.voyageSaver_starmap.load(d.starmap);
        return true;
    }
    else {
        console.log('complete load');
        return false;
    }
};
exports.load = load;
var deleteSave = function (saveSlot) {
    localStorer_sidecar_1.localStorer.deleteKeysLike(key + saveSlot);
};
exports.deleteSave = deleteSave;
